export default __webpack_public_path__ + "static/media/icon_kick_available_active.f2b10009.png";